import React, { useEffect, useState, useContext } from 'react'
// import { Dialog, Input, Form, Stepper, Switch, Toast } from 'antd-mobile';
import { Spin, Segmented, ConfigProvider, Select, message, Form } from 'antd'
import KitDetailContent from '@/pages/orderServiceSpaceChoose/components/KitDetailContent'
import styles from './index.module.less'
import { SDrawerOrModal } from 'shj-components'

const ChooseCombinateSkuModal = ({
  open = false,
  closeDialog = () => ({}),
  productInfo = {},
  combinationInfoList = [],
  confirmInfo = () => ({}),
}: any) => {
  const [form] = Form.useForm()
  const [spinLoading, setSpinLoading] = useState(false)
  const [mustChooseList, setMustChooseList] = useState<Array<any>>([])
  const [noMustChooseList, setNoMustChooseList] = useState<Array<any>>([])

  useEffect(() => {
    productInfo?.combinationInfo && getCombination()
  }, [productInfo])

  const formatCombinationData = (must: any, noMust: any, format = false) => {
    // 组合数据处理
    console.log(must, noMust, '组合数据处理----------')
    const newMustChooseList = must.map(item => {
      // 只有一个sku就默认选中，且不能修改规格，相对应就没有回显的逻辑
      if (item.selectedSkuList?.length === 1) {
        return {
          ...item,
          selectSkuId: item.selectSkuId,
          selectPrice: item.selectPrice || '',
          checked: true,
          useArgList: [],
          onlyOne: true,
        }
      }

      let skuId = ''
      let price = ''
      const skuMap: any = {}
      // 处理规格
      const selectArgList = item?.useArgList?.map(arg => {
        const choose = arg?.list?.filter(choice => choice.isActive) || []
        skuMap[arg.argCode] = choose?.[0]?.valueId
        return {
          argId: arg.argId,
          argCode: arg.argCode,
          argType: arg.argType,
          argValCode: choose?.[0]?.valueCode,
          argVal: choose?.[0]?.valueId,
        }
      })
      // 找sku
      item?.selectedSkuList?.forEach(sku => {
        const codeList = Object.keys(sku.argMap)
        const selectedCodeList = Object.keys(skuMap)
        if (codeList?.length === selectedCodeList?.length) {
          const filterList = codeList.filter(code => {
            return skuMap[code] === sku.argMap?.[code]?.valueId
          })
          if (filterList?.length === codeList?.length) {
            skuId = sku.id
          }
        }
      })
      console.log(skuId, price, item, 'item', 'skuId, price')
      return {
        ...item,
        selectSkuId: skuId,
        selectArgList,
        selectPrice: price ? Number(price).toFixed(4) : '',
        checked: true,
      }
    })
    // 非必选
    const newNoMustChooseList = noMust.map(item => {
      if (!item.checked) {
        return {
          ...item,
          selectSkuId: '',
          // selectArgList: [],
        }
      }
      // 只有一个sku就默认选中，且不能修改规格，相对应就没有回显的逻辑
      if (item.selectedSkuList?.length === 1) {
        return {
          ...item,
          selectSkuId: item.selectedSkuList?.[0]?.id,
          selectPrice: item.selectPrice || '',
          checked: true,
          useArgList: [],
          onlyOne: true,
        }
      }

      let skuId = ''
      let price = 0
      const skuMap: any = {}
      // 处理规格
      const selectArgList = item?.useArgList?.map(arg => {
        const choose = arg?.list?.filter(choice => choice.isActive) || []
        skuMap[arg.argCode] = choose?.[0]?.valueId
        return {
          argId: arg.argId,
          argCode: arg.argCode,
          argType: arg.argType,
          argValCode: choose?.[0]?.valueCode,
          argVal: choose?.[0]?.valueId,
        }
      })
      // 找sku
      item?.selectedSkuList?.forEach(sku => {
        const codeList = Object.keys(sku.argMap)
        const selectedCodeList = Object.keys(skuMap)
        if (codeList?.length === selectedCodeList?.length) {
          const filterList = codeList.filter(code => {
            return skuMap[code] === sku.argMap?.[code]?.valueId
          })
          if (filterList?.length === codeList?.length) {
            skuId = sku.id
          }
        }
      })
      return {
        ...item,
        selectSkuId: skuId,
        selectPrice: price ? Number(price).toFixed(4) : '',
        selectArgList,
        checked: true,
      }
    })
    setMustChooseList(newMustChooseList)
    setNoMustChooseList(newNoMustChooseList)
    console.log('选中数据——————', newMustChooseList, newNoMustChooseList)
    return [...newMustChooseList, ...newNoMustChooseList]
  }

  const confirmDialog = () => {
    // 组合数据处理
    const combinationInfo = formatCombinationData(mustChooseList, noMustChooseList)
    const hasSkuList = combinationInfo.filter(item => item.selectSkuId)
    const hasCheckedList = combinationInfo.filter(item => item.checked)
    // const
    let noSkuProdInfo:any = {}
    if (hasSkuList?.length !== hasCheckedList?.length) {
      noSkuProdInfo = hasCheckedList?.filter(item => !item.selectSkuId)?.[0]
      message.error(
        `产品SPU：${noSkuProdInfo?.prodName}-${noSkuProdInfo?.id}未对应上SKU，请检查，可能原因：①没有适用该门店的SKU；②未选择商品规格`
      )
      return
    }
    confirmInfo(combinationInfo)
    closeDialog()
  }

  const getCombination = async () => {
    try {
      // 处理组合数据，这地方就比较复杂了，要把必选项和非必选抽出来，同时处理他们各自的规格数据，因为规格数据只能从所有选择的sku里面提取，没有现成数据
      // 且提取完使用的规格，后续规格选择之间还要做选项联动
      if (productInfo && productInfo.combinationInfo?.length) {
        /**
         * 价格计算逻辑
         */
        //handleSetPrice(productInfo)
        const formatSpecList = productInfo.combinationInfo?.map((com: any) => {
          // 只有一个sku就默认选中，且不能修改规格，相对应就没有回显的逻辑
          console.log('com----------', com)

          const useArgMap: any = {} // 所有用过的规格和值
          com.selectedSkuList.forEach((sku: any) => {
            const keys = Object.keys(sku?.argMap)
            keys.forEach(key => {
              if (useArgMap[key]?.length) {
                if (!useArgMap[key].includes(sku?.argMap[key]?.valueId)) {
                  useArgMap[key].push(sku?.argMap[key]?.valueId)
                }
              } else {
                useArgMap[key] = [sku?.argMap[key]?.valueId]
              }
            })
          })

          const chooseSkuId = com.selectedSkuList?.length === 1 ? com.selectedSkuList?.[0]?.id : ''
          // 处理回显
          const filterComMap: any = {}
          let filterCom: any = {}
          if (chooseSkuId) {
            const chooseSku = com.selectedSkuList.filter((item: any) => item.id === chooseSkuId)[0]
            const chooseSkuArgMap = chooseSku?.argMap || {}
            filterCom = com
            filterCom.selectSkuId = chooseSkuId
            for (const valueKey in chooseSkuArgMap) {
              const value = chooseSkuArgMap[valueKey]
              if (value && value.valueId) {
                filterComMap[valueKey] = value.valueId
              }
            }
          } else if (combinationInfoList?.length) {
            // 选材时回显
            const filterList = combinationInfoList.filter((info: any) => info.id === com.id)
            if (filterList?.length) {
              filterCom = filterList[0]
              filterCom?.selectArgList?.forEach(
                (arg: any) => (filterComMap[arg?.argCode] = arg.argVal)
              )
            }
          }

          const useArgList = Object.keys(useArgMap)?.map((useKey: any) => {
            const spec = com.product.specificationArgList?.find(
              (item: any) => item.argCode === useKey
            )
            let newList = spec?.values?.filter(
              (item: any) => useArgMap[useKey]?.includes(item.valueId)
            )
            newList.forEach((item: any) => {
              item.isActive = filterComMap[useKey] === item.valueId
            })

            return {
              argCode: spec?.argCode,
              argName: spec?.argName,
              argId: spec?.id,
              argType: spec?.argType,
              list: newList,
            }
          })
          return {
            ...com,
            selectSkuId: filterCom?.selectSkuId || '',
            selectPrice: filterCom.selectPrice || '',
            materialDynaOptions: filterCom?.materialDynaOptions || [],
            useArgList: com.selectedSkuList?.length === 1 ? [] : useArgList,
          }
        })
        const mustChooseList = formatSpecList.filter((item: any) => item.required)
        const noMustChooseList = formatSpecList.filter((item: any) => !item.required)
        setMustChooseList(mustChooseList)
        setNoMustChooseList(noMustChooseList)
      } else {
        message.error('无组合数据')
      }
    } catch (err) {
      console.log(err)
    }
  }

  const combinationContent = () => {
    return (
      <div className={styles.mainAndExtraContent}>
        <div className={styles.kitBox}>
          <KitDetailContent
            kitList={mustChooseList}
            noMustChooseList={noMustChooseList}
            setMustChooseList={setMustChooseList}
            setNoMustChooseList={setNoMustChooseList}
            formatCombinationData={formatCombinationData}
          />
        </div>
      </div>
    )
  }

  const dialogContent = () => {
    return (
      <Spin spinning={spinLoading}>
        <div
          className={styles.SpecificationDialogBox}
          style={{
            padding: '0 3px 0 3px',
          }}
        >
          <Form
            form={form}
            layout="horizontal"
            initialValues={{
              quoteBudgetVariableVos: [],
              spaceQuoteBudgetItemList: [],
              specsList: [],
            }}
            style={{
              width: '100%',
            }}
          >
            {combinationContent()}
          </Form>
        </div>
      </Spin>
    )
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            itemSelectedBg: 'rgba(0, 100, 255, 1)',
            itemSelectedColor: '#fff',
            itemHoverBg: 'rgba(0, 100, 255, 1)',
            itemHoverColor: '#fff',
          },
        },
      }}
    >
      <div className={styles.specsDialog}>
        <SDrawerOrModal
          open={open}
          mode="modal"
          onCancel={closeDialog}
          title="产品明细"
          children={dialogContent()}
          width={1000}
          onOk={confirmDialog}
          antdProps={{ maskClosable: false, destroyOnClose: true }}
        />
      </div>
    </ConfigProvider>
  )
}

export default ChooseCombinateSkuModal
